

export const descriptions =[ 
"I/We, in regard to my/our claim under RoDTEP scheme made in this Shipping Bill or Bill of Export, hereby declare that: 1. I/ We undertake to abide by the provisions, including conditions, restrictions, exclusionsand time-limits as provided under RoDTEP scheme, and relevant notifications,regulations, etc., as amended from time to time. 2. Any claim made in this shipping bill or bill of export is not with respect to any duties or taxes or levies which are exempted or remitted or credited under any other mechanism outside RoDTEP. 3. I/We undertake to preserve and make available relevant documents relating to the exported goods for the purposes of audit in the manner and for the time period prescribed in the Customs Audit Regulations, 2018.",

"I declare that no input tax credit of the Central Goods and Services Tax or of the Integrated Goods and Services Tax has been availed for any of the inputs or input services used in the manufacture of the export goods.",

 "I declare that no refund of Integrated Goods and Services Tax paid on export goods shall be claimed.",

  "I declare that CENVAT credit on the inputs or input services used in the manufacture of the export goods has not been carried forward in terms of the Central Goods and Services Tax Act, 2017.",

"1. I/ We undertake to abide by the provisions, including conditions, restrictions, exclusions and time-limits as provided under RoSCTL scheme, and relevant notifications, regulations, etc., as amended from time to time. 2. Any claim made in this shipping bill or bill of export is not with respect to any duties or taxes or levies which are exempted or remitted or credited under any other mechanism outside RoSCTL. 3. I/ We undertake to preserve and make available relevant documents relating to the exported goods for the purposes of audit in the manner and for the time period prescribed in the Customs Audit Regulations, 2018."
]


export default {
  row1: [
    {
      column: "column1",
    //   columnWidth: "45%",
      rows: {
        row1: [
          {
            name: "declarationType",
            label: "Declaration Type",
            component: "dropdown",
            width:"49%",
            options: [
              {
                label: "Declaration",
                value: "Declaration",
              },
              {
                label: "Undertaking",
                value: "Undertaking",
              },
              {
                label: "Remark",
                value: "Remark",
              },
            ],
          },
          {
            name: "declarationCode",
            label: "Title",
            component: "dropdown",
            width:"49%",
            options: [
              {
            label: "DB001-DBK Declaration - No IGST ITC availed",
            value: "DB001-DBK Declaration - No IGST ITC availed",
          },
          {
            label: "DB002-DBK Declaration - No IGST Refund claimed",
            value: "DB002-DBK Declaration - No IGST Refund claimed",
          },
          {
            label: "DB003-DBK Declaration - No CENVAT credit carry forward",
            value: "DB003-DBK Declaration - No CENVAT credit carry forward",
          },
          {
            label: "RD001 - RODTEP Declaration",
            value: "RD001 - RODTEP Declaration",
          },
          {
            label: "R5001 - ROSCTL Declaration",
            value: "R5001 - ROSCTL Declaration",
          },
            ]
          },
        ],
        row2 : [
              {
            name: "declarationRemarks",
            component: "textarea",
            width: "100%",
            height: 100,
            sx: {
              borderRadius: 10,
            },
            disabled: true,
            isGet: false,
          },
        ]
      },
    },
  ],
};



 